import { useState, useEffect, useRef } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";

const WorkoutNameEditor = (props) => {
  const [workoutName, setWorkoutName] = useState(props.workoutName);
  const [previousWorkouts, setPreviousWorkouts] = useState(
    props.previousWorkouts
  );
  const [suggestionsState, setSuggestionsState] = useState({
    showSuggestions: false,
    suggestions: [],
  });
  const inputRef = useRef(null);

  useEffect(() => {
    setWorkoutName(props.workoutName);
    setPreviousWorkouts(props.previousWorkouts);
  }, [props.workoutName, props.previousWorkouts]);

  const handleWorkoutNameChange = (event) => {
    const userInput = event.target.value;
    setWorkoutName(userInput);
    props.onWorkoutNameChange(userInput);
    const filteredSuggestions = previousWorkouts.filter(
      (suggestion) =>
        suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );

    if (userInput !== "")
      setSuggestionsState({
        suggestions: filteredSuggestions,
        showSuggestions: true,
      });
    else
      setSuggestionsState({
        suggestions: previousWorkouts,
        showSuggestions: true,
      });
  };

  const handleWorkoutNameFocus = () => {
    const filteredSuggestions = previousWorkouts.filter(
      (suggestion) =>
        suggestion.toLowerCase().indexOf(workoutName.toLowerCase()) > -1
    );
    if (workoutName !== "")
      setSuggestionsState({
        suggestions: filteredSuggestions,
        showSuggestions: true,
      });
    else {
      setSuggestionsState({
        suggestions: previousWorkouts,
        showSuggestions: true,
      });
    }
  };

  const handleWorkoutNameBlur = (event) => {
    const relatedTarget = event.relatedTarget;
    if (
      relatedTarget &&
      relatedTarget.getAttribute("type") === "workout-suggestion"
    ) {
      const suggestedWorkoutName = relatedTarget.innerText;
      setWorkoutName(suggestedWorkoutName);
      props.onWorkoutNameChange(suggestedWorkoutName);
      setSuggestionsState({
        ...suggestionsState,
        showSuggestions: false,
      });
    } else {
      setWorkoutName(workoutName.trim());
      props.onWorkoutNameChange(workoutName.trim());
      setSuggestionsState({
        ...suggestionsState,
        showSuggestions: false,
      });
    }
  };

  const handleInputCleared = () => {
    setWorkoutName("");
    if (inputRef.current) {
      inputRef.current.focus();
    }
    setSuggestionsState({
      suggestions: previousWorkouts,
      showSuggestions: true,
    });
  };

  return (
    <div className="relative">
      <label
        htmlFor="workout-name"
        className="block mb-1 text-sm font-medium text-gray-700"
      >
        Workout Name
      </label>
      <div className="relative">
        {workoutName !== "" && (
          <XMarkIcon
            className="h-5 w-auto text-gray-400 absolute top-[19px] -translate-y-1/2 right-3"
            aria-hidden="true"
            onClick={handleInputCleared}
          />
        )}
        <input
          name="workout-name"
          type="text"
          autoComplete="off"
          tabIndex={-1}
          className={classNames(
            "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 text-sm",
            {
              "pr-10": workoutName !== "",
            }
          )}
          placeholder="Ex. Leg Day - Week 1"
          value={workoutName}
          ref={inputRef}
          onChange={handleWorkoutNameChange}
          onFocus={handleWorkoutNameFocus}
          onBlur={handleWorkoutNameBlur}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
            }
          }}
        />
      </div>
      {suggestionsState.showSuggestions &&
        suggestionsState.suggestions.length > 0 && (
          <div className="absolute z-50 w-full left-0 top-[calc(100%+8px)]">
            <div className="py-1 flex flex-col bg-white shadow-lg ring-1 ring-black ring-opacity-5 w-full rounded-md overflow-y-scroll max-h-[234px]">
              <span className="text-xs text-gray-500 px-3 pb-3 pt-3">
                Suggestions based on your previous workouts
              </span>
              {suggestionsState.suggestions &&
                suggestionsState.suggestions.length !== 0 &&
                suggestionsState.suggestions.map((suggestion) => {
                  return (
                    <div
                      type="workout-suggestion"
                      className="relative text-gray-700 text-left px-3 py-[9px] text-sm w-full hover:cursor-pointer"
                      key={suggestion}
                      tabIndex={0}
                    >
                      {suggestion}
                    </div>
                  );
                })}
            </div>
          </div>
        )}
    </div>
  );
};

export default WorkoutNameEditor;
